import { render, staticRenderFns } from "./ChartDragItem.vue?vue&type=template&id=61e2ed24&scoped=true"
import script from "./ChartDragItem.vue?vue&type=script&lang=js"
export * from "./ChartDragItem.vue?vue&type=script&lang=js"
import style0 from "./ChartDragItem.vue?vue&type=style&index=0&id=61e2ed24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2ed24",
  null
  
)

export default component.exports